import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AppStorageState, LAYOUT_FEATURE_KEY} from '../../../storage/storage.state';

export const checkoutFeature = createFeatureSelector<AppStorageState>(LAYOUT_FEATURE_KEY);
export const selectLoading = createSelector(
  checkoutFeature,
  (state: AppStorageState) => {
    return state.contacts.isLoading;
  }
);
export const selectUpdating = createSelector(
  checkoutFeature,
  (state: AppStorageState) => {
    return state.contacts.isUpdating;
  }
);
export const selectResponse = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data
);
export const selectItems = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.data
);
export const selectPageSize = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.pageSize
);
export const selectPageNo = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.pageIndex
);
export const selectCount = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.count
);
export const selectTotalData = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.totalCount
);
export const selectTotalPage = createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts.data.totalPages
);
export const selectDefaultContactByCode = (code) => createSelector(
  checkoutFeature,
  (state: AppStorageState) => state.contacts?.data?.data?.find(x => x.code == code)
);

export const selectDefaultContact = createSelector(
  checkoutFeature,
  (state: AppStorageState) => { return state.contacts?.data?.data?.find(x => x.isDefault); }
);

/*export const selectUpdatedContact = createSelector(
  checkoutFeature,
  (state: AppState) => state.contacts.data.data
);*/
